// src/composables/useProfileSocial.js
import { ref, computed } from '@vue/composition-api'
import store from '@/store'
import analytics from '@/@core/utils/analytics'
import constants from '@/constants'
import { UPDATE_ENTITY } from '@/store/modules/auth.module'
import { apiToastSuccess } from '@/@core/utils/toast'
import { formatEntityData } from '@/utils/formatEntityData'

export function useProfileSocial() {
  // --- Reactive State ---
  const socialLocal = ref({})
  const saving = ref(false)

  // --- Computed ---
  const isNotEntityAdmin = computed(() => !store.getters.isEntityAdmin)

  // --- Methods ---
  function buildDefault(socialData) {
    if (socialData && Object.keys(socialData).length) {
      return JSON.parse(JSON.stringify(socialData))
    }
    return {
      websiteLink: '',
      instagramLink: '',
      facebookLink: '',
      linkedinLink: '',
      twitterLink: '',
      websiteLinkError: false,
    }
  }

  function initSocial(socialData) {
    socialLocal.value = buildDefault(socialData)
  }

  async function saveForm() {
    saving.value = true
    try {
      const payload = { ...socialLocal.value }
      delete payload.websiteLinkError
      const entityData = formatEntityData({ ...store.getters.entityData })
      await store.dispatch(UPDATE_ENTITY, {
        ...entityData,
        ...payload,
      })
      apiToastSuccess('Social links updated successfully')
      analytics.track(constants.TRACKS.ACTIONS.SAVE_PROFILE_SETTINGS_SOCIAL)
      return { success: true, payload: socialLocal.value }
    } catch {
      return { success: false }
    } finally {
      saving.value = false
    }
  }

  function resetForm(socialData) {
    initSocial(socialData)
  }

  return {
    socialLocal,
    saving,
    isNotEntityAdmin,
    initSocial,
    saveForm,
    resetForm,
  }
}
